export interface ProjectLocalConfig {
  disabledPages?: string[];
}

const defaultConfig: ProjectLocalConfig = {
  disabledPages: [],
};

export function getProjectLocalConfig(project: string): ProjectLocalConfig {
  return extendDefaultConfig(projectsLocalConfig[project]);
}

function extendDefaultConfig(
  config: Partial<ProjectLocalConfig> = {},
): ProjectLocalConfig {
  return {
    ...defaultConfig,
    ...config,
  };
}

const projectsLocalConfig: Record<string, Partial<ProjectLocalConfig>> = {
  demo: {
    disabledPages: [],
  },
};
export type ProjectIdentifier = keyof typeof projectsLocalConfig;
